import React from "react";

import type { SvgIconProps } from "@mui/material";
import styled from "@mui/material/styles/styled";

import { Row } from "@rui/Stack";
import TooltipWrapper from "@rui/TooltipWrapper";

type CountChipProps = {
  Icon: React.FunctionComponent<SvgIconProps>;
  children: React.ReactNode;
  tooltip?: string;
};

const CountChip = styled<React.FC<CountChipProps>>(
  ({ Icon, children, tooltip, ...props }) => (
    <TooltipWrapper title={tooltip}>
      <Row {...props} variant="left" spacing={0.5}>
        <Icon />
        {children}
      </Row>
    </TooltipWrapper>
  )
)(({ theme }) => ({
  width: "fit-content",
  backgroundColor: theme.palette.transparent.black[4],
  borderRadius: theme.corners.small,
  padding: "2px 4px",
  color: theme.palette.shades.neutral[500],
  fontSize: "11px",
  "& .MuiSvgIcon-root": {
    color: theme.palette.shades.neutral[300],
    fontSize: "11px",
  },
}));

export default CountChip;
